/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'

const HeaderUserMenu: FC = () => {
  const {currentUser} = useAuth()
  const {logout} = useAuth()
  const navigate=useNavigate();
  const api_token: string =
    JSON.parse(localStorage.getItem('kt-auth-react-v') || '')?.api_token || null;
    const authData= JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
  return (
    <div
    className='menu menu-sub menu-sub-dropdown menu-column menu-rounded shadow-sm p-4 bg-white w-275px'
    data-kt-menu='true'
  >
    <div className='menu-item'>
      <div className='d-flex align-items-center'>
        <div className='symbol symbol-50px me-4'>
          <div className='symbol symbol-100px position-relative'>
            {authData.user.picture ? (
              <img
                src={authData.user.picture}
                alt='Profile Pic'
                className='img-fluid rounded-circle shadow-sm'
              />
            ) : (
              <div className='symbol symbol-circle bg-dark text-white d-flex align-items-center justify-content-center' style={{ height: '50px', width: '50px' }}>
                <span className='fs-3 fw-bold'>
                {
                  
                  +
                  -authData.user?.is_superadmin ===1?(
                    authData.user.full_name ? authData.user.full_name[0].toUpperCase() : ''
                  ):( authData.user.full_name ? authData.user.full_name[0].toUpperCase() : '')
                }
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='d-flex flex-column'>
          <div className='fw-bold fs-5 text-dark'>
            {authData.user.full_name}
            <span className='badge badge-light-success ms-2'>Online</span>
          </div>
          <span className='text-muted fs-7'>
            {authData.user.email}
          </span>
        </div>
    </div>
      <div className='separator my-4'></div>
      <div className='menu-item'>
        <Link to='/crafted/pages/profile' className='menu-link text-dark'>
          <i className='bi bi-person-circle me-2'></i>
          My Profile
        </Link>
      </div>
    <div className='menu-item'>
      <Link to='/crafted/account/settings' className='menu-link text-dark'>
        <i className='bi bi-gear me-2'></i>
        Account Settings
      </Link>
    </div>

    <div className='separator my-4'></div>

    <div className='menu-item'>
        <a
          onClick={() => {
            navigate('/logout');
          }} 
        className='menu-link text-danger'
        style={{ cursor: 'pointer' }}
      >
        <i className='bi bi-box-arrow-right me-2'></i>
        Sign Out
      </a>
    </div>
  </div>
  )
}
export {HeaderUserMenu}
